import type { ChatThreadSummary } from '@app/types/org-console';
import { hasChatThreadTag, TOPOLOGY_WORKBENCH_THREAD_TAG } from './chatThreadTags';

export interface ChatThreadFilterOptions {
  currentUserId: string | null;
  ownerFilter: 'mine' | 'all';
  visibilityFilter: 'all' | 'org' | 'private';
  onlyPinned: boolean;
  normalizedSearch: string;
  isPinned: (thread: ChatThreadSummary) => boolean;
}

export const chatThreadMatchesFilters = (thread: ChatThreadSummary, options: ChatThreadFilterOptions): boolean => {
  if (hasChatThreadTag(thread, TOPOLOGY_WORKBENCH_THREAD_TAG)) {
    return false;
  }

  const threadOwnerId = thread.createdByUserId ?? thread.createdBy;
  if (options.ownerFilter === 'mine' && options.currentUserId && threadOwnerId && threadOwnerId !== options.currentUserId) {
    return false;
  }

  if (options.visibilityFilter !== 'all' && thread.visibility !== options.visibilityFilter) {
    return false;
  }

  if (options.onlyPinned && !options.isPinned(thread)) {
    return false;
  }

  const normalizedSearch = options.normalizedSearch.trim().toLowerCase();
  if (!normalizedSearch) {
    return true;
  }

  const haystack = `${thread.title ?? ''} ${(thread.tags ?? []).join(' ')}`.toLowerCase();
  return haystack.includes(normalizedSearch);
};
